import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        report: '=',
        comparisonReport: '=',
        isEvaluableReport: '=',
        summaryText: '='
    },
    template: `
        <p ng-bind-html="vm.summaryText"></p>
        <div class="items09">
            <div class="item">
                <ul class="ticks">
                    <!--NOTE: CURRENTLY ALL ELEMENTS HAVE SAME DISTANCE FROM ONE-ANOTHER (points value unused) -->
                    <li ng-repeat="answer in vm.categoriesForm.answerOptions">{{ answer.label }}</li>
                </ul>
                <dl>
                    <dt ng-if="vm.isEvaluableReport" class="primary">{{ 'report.Aggregate summary' | translate }}</dt>
                    <dt ng-if="!vm.isEvaluableReport" class="primary">{{ 'report.Total results' | translate }}</dt>
                    <dd>
                        <evaluation-public-report-partials-bar
                            average="vm.categoriesForm.average"
                            count="vm.categoriesForm.answerOptions.length"
                            group-average="vm.categoriesForm.groupAverage"
                            show-title="vm.comparisonReport!==undefined"
                            title="vm.report.groupName"
                        />
                        <evaluation-public-report-partials-bar
                            ng-if="vm.comparisonCategoriesForm"
                            average="vm.comparisonCategoriesForm.average"
                            count="vm.comparisonCategoriesForm.answerOptions.length"
                            group-average="vm.comparisonCategoriesForm.groupAverage"
                            is-comparison="true"
                            title="vm.comparisonReport.groupName"
                        />
                    </dd>
                </dl>
            </div>
            <div class="item">
                <ul class="ticks">
                    <!--NOTE: CURRENTLY ALL ELEMENTS HAVE SAME DISTANCE FROM ONE-ANOTHER (points value unused) -->
                    <li ng-repeat="answer in vm.categoriesForm.answerOptions">{{ answer.label }}</li>
                </ul>
                <dl>
                    <dt ng-repeat-start="category in vm.categoriesForm.categories"
                        ng-init="comparisonCategory = vm.comparisonCategoriesForm.categories[$index]"
                    >{{ category.name }}</dt>
                    <dd ng-repeat-end>
                        <evaluation-public-report-partials-bar
                            average="category.average"
                            count="vm.categoriesForm.answerOptions.length"
                            group-average="category.groupAverage"
                            show-title="vm.comparisonReport!==undefined"
                            title="vm.report.groupName"
                        />
                        <evaluation-public-report-partials-bar
                            ng-if="comparisonCategory"
                            average="comparisonCategory.average"
                            count="vm.comparisonCategoriesForm.answerOptions.length"
                            group-average="comparisonCategory.groupAverage"
                            is-comparison="true"
                            title="vm.comparisonReport.groupName"
                        />
                    </dd>
                </dl>
            </div>
        </div>
    `
})
export default class {
    constructor (lodash) {
        this.lodash = lodash;
    }

    $onInit () {
        this.categoriesForm = this.lodash.get(this.report, 'categoriesForm', {});
        this.comparisonCategoriesForm = this.lodash.get(this.comparisonReport, 'categoriesForm', {});
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/report/category/summary/index.js